import React from 'react';
import { Link } from 'react-router-dom';
import { Globe, Network, Wifi, Radio, ChevronRight } from 'lucide-react';

interface AssetCounts {
  domains: number;
  subdomains: number;
  ip_addresses: number;
  ports: number;
}

interface AssetTypeCard {
  title: string;
  path: string;
  icon: React.ElementType;
  countKey: keyof AssetCounts;
  color: string;
  description: string;
}

const assetTypes: AssetTypeCard[] = [
  {
    title: 'Domains',
    path: '/domains',
    icon: Globe,
    countKey: 'domains',
    color: 'text-blue-500',
    description: 'Root domains under monitoring'
  },
  {
    title: 'Subdomains',
    path: '/subdomains',
    icon: Network,
    countKey: 'subdomains',
    color: 'text-purple-500',
    description: 'Active subdomains discovered'
  },
  {
    title: 'IP Addresses',
    path: '/ip-addresses',
    icon: Wifi,
    countKey: 'ip_addresses',
    color: 'text-emerald-500',
    description: 'Unique IP addresses identified'
  },
  {
    title: 'Open Ports',
    path: '/ports',
    icon: Radio,
    countKey: 'ports',
    color: 'text-yellow-500',
    description: 'Active ports detected'
  }
];

interface AssetOverviewCardsProps {
  asset_counts: AssetCounts;
}

export const AssetOverviewCards = ({ asset_counts }: AssetOverviewCardsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {assetTypes.map((type) => {
        const Icon = type.icon;
        return (
          <Link
            key={type.path}
            to={type.path}
            className="bg-[#0F1629]/50 rounded-xl p-6 hover:bg-[#0F1629] transition-colors group relative overflow-hidden"
          >
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/[0.05] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            <div className="relative">
              <div className="flex items-center justify-between mb-4">
                <div className={`p-2 rounded-lg bg-gray-800/30 ${type.color}`}>
                  <Icon className="h-5 w-5" />
                </div>
                <ChevronRight className="h-4 w-4 text-gray-500 group-hover:text-gray-400 transition-colors" />
              </div>
              
              <div className="space-y-1">
                <div className="text-2xl font-bold text-white">{asset_counts[type.countKey]}</div>
                <div className="text-sm font-medium text-gray-300">{type.title}</div>
                <div className="text-xs text-gray-500">{type.description}</div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
};